export default __webpack_public_path__ + "static/media/bulletIcon.2b9c827e.svg";